module.exports = __webpack_public_path__ + "r-v3/img/logo_grm_tx_white.05e4f375.svg";